import type { WsCallRecord } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { CallRecord } from "@/store/types";

function transformWsCallRecord(r: WsCallRecord): CallRecord {
  return {
    id: r.id,
    contentId: r.contentId,
    fromAccountId: r.fromAccountId,
    fromDisplayName: r.fromDisplayName,
    fromAlias: r.fromAlias,
    toAccountId: r.toAccountId,
    toDisplayName: r.toDisplayName,
    toAlias: r.toAlias,
    durationSeconds: r.durationSeconds ?? null,
    callStatus: r.callStatus,
    createdAt: r.createdAt ?? null,
  };
}

export async function bulkUpsertCallRecord(records: WsCallRecord[]) {
  if (records.length === 0) return;
  store.upsert("callRecord", records.map(transformWsCallRecord));
}
